<script lang="ts">
  import PublicWebNav from '$lib/components/PublicWebNav/PublicWebNav.svelte';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import FooterComponent from '$components/contentful/standard/FooterComponent/FooterComponent.svelte';
  import type { PageData } from './$types';

  export let data: PageData;
</script>

<svelte:head>
  {#if data.dynamicStyles}
    <!-- eslint-disable-next-line svelte/no-at-html-tags allow dynamic css is produced by view models -->
    {@html data.dynamicStyles}
  {/if}
</svelte:head>

{#if data.navProps}
  <svelte:boundary onerror={console.error}><PublicWebNav {...data.navProps} /></svelte:boundary>
{/if}

<main id="main-content">
  <DynamicChildrenComponent children={data.entry} />
</main>

{#if data.footerProps}
  <svelte:boundary onerror={console.error}><FooterComponent {...data.footerProps} /></svelte:boundary>
{/if}
